import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import {BehaviorSubject, filter, Observable, switchMap, throwError} from 'rxjs';
import {environment} from "../environments/environment";
import {AuthService} from "./services/auth.service";
import {catchError, finalize, take, tap} from "rxjs/operators";
import {LoginService} from "./services/login.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private refreshTokenInProgress = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        private _auth: AuthService,
        private loginService: LoginService
    ) {
    }

    addAuthenticationToken(request: HttpRequest<unknown>) {
        return request.clone({
            setHeaders: {
                Authorization: 'Bearer ' + this._auth.getBearerToken()
            }
        });
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        if (request.url.includes(environment.apiEndPoint) && !request.url.includes('/user/auth/login')) {
            request = this.addAuthenticationToken(request);
        }

        return next.handle(request).pipe(
            tap({
                error: (error) => {
                    if (error.status === 401) {
                        // this._auth.logout();

                        if (this.refreshTokenInProgress) {
                            return this.refreshTokenSubject.pipe(
                                filter(result => result !== null),
                                take(1),
                                switchMap(() => next.handle(this.addAuthenticationToken(request)))
                            );
                        } else {
                            // Set the refreshTokenSubject to null so that subsequent API calls
                            // will wait until the new token has retrieved
                            this.refreshTokenInProgress = true;
                            this.refreshTokenSubject.next(null);
                            return this.loginService.refreshToken().then((res: any)=>{
                                console.log(res)
                                localStorage.setItem('token', JSON.stringify(res.token));
                                this.refreshTokenSubject.next(true);
                                return next.handle(this.addAuthenticationToken(request))
                            }).catch(err=>{
                                if (err.status == 422 || err.status == 401) {
                                    this._auth.logout();
                                }
                                return throwError(err);
                            }).finally(()=>{
                                this.refreshTokenInProgress = false
                            })
                        }
                    }
                    return throwError(() => error);
                }
            })
        );

    }
}
